import React from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { refreshToken } from '../../../api/api';
import { setAuthorization } from '../../../api/httpClient';

interface ConfigValidationModalProps {
    isOpen: boolean;
    isAdmin: boolean;
}

const ConfigValidationModal: React.FC<ConfigValidationModalProps> = ({ isOpen, isAdmin }) => {
    const navigate = useNavigate();

    const handleRefresh = async () => {
        try {
            const authUser = localStorage.getItem("authUser");
            if (authUser) {
                const user = JSON.parse(authUser);
                if (user.token) {
                    const refreshResponse = await refreshToken();
                    
                    if (refreshResponse && refreshResponse.token) {
                        const newToken = refreshResponse.token;
                        user.token = newToken;
                        localStorage.setItem("authUser", JSON.stringify(user));
                        setAuthorization(newToken);
                        window.location.reload();
                    }
                }
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
        }
    };

    const handleGoToConfig = () => {
        navigate('/company-profile/');
    };

    return (
        <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
            <ModalHeader>
                <div className="d-flex align-items-center">
                    <span className="fw-bold">
                        {isAdmin ? "Configuración incompleta" : "Configuración requerida"}
                    </span>
                </div>
            </ModalHeader>
            <ModalBody className="text-center p-4">
                <div className="mb-4">
                    <i className="ri-settings-3-line text-muted" style={{ fontSize: '3rem' }}></i>
                </div>
                
                <p className="text-muted fs-15">
                    {isAdmin
                        ? "Aún no has configurado un establecimiento o punto de emisión. Complétalo para poder emitir facturas correctamente."
                        : "No tienes un establecimiento o punto de emisión asignado. Por favor, solicita a un administrador que te asigne uno para poder emitir facturas correctamente."
                    }
                </p>

                <div className="d-flex gap-2 justify-content-end mt-4">
                    {isAdmin ? (
                        <>
                            <Button color="primary" onClick={handleGoToConfig}>
                                Ir a configurar
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button color="primary" onClick={handleRefresh}>
                                <i className="ri-refresh-line me-1"></i> Refrescar
                            </Button>
                            <Button color="light" onClick={() => navigate('/dashboard')}>
                                Entendido
                            </Button>
                        </>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ConfigValidationModal;
